module.exports = __webpack_public_path__ + "static/media/aerial2Dark50.64757ee3.jpg";